module.exports = __webpack_public_path__ + "static/media/logo_movil.6e9e235a.png";